import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modePlagalFourth';
const args = {};

export class ModePlagalFourth extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
